import React from 'react';
import { withParentSize } from '@visx/responsive';
import QuestionResults from '../QuestionResults';
import { useAssessmentReviewContext } from '../AssessmentReviewContext';

function StandardQuestionResults({ question, parentWidth }) {
  return <QuestionResults question={question} width={parentWidth} />;
}

const SizedQuestionResults = withParentSize(StandardQuestionResults);

/** A standard page's questions, each asked once, in the standard results grid. */
function StandardPageResults({ page }) {
  const { questionMap } = useAssessmentReviewContext();

  return (
    <div className="survey-review-grid">
      {(page.elements ?? []).map((element) => {
        const question = questionMap[element.key];
        return question ? (
          <SizedQuestionResults key={element.guid} question={question} />
        ) : null;
      })}
    </div>
  );
}

export default StandardPageResults;
